import styled, { css } from "styled-components";

export type ClockLevel = "calm" | "warn" | "bad";

const LEVELS: Record<ClockLevel, [bg: string, fg: string, border: string, bar: string]> = {
  calm: ["var(--card)", "var(--ink)", "var(--ink)", "var(--teal)"],
  warn: ["var(--warn-bg)", "var(--warn)", "var(--gold-shade)", "var(--gold)"],
  bad: ["var(--bad-bg)", "var(--bad)", "var(--cherry-shade)", "var(--cherry)"],
};

export const ClockContainer = styled.div<{ $show?: boolean }>`
  max-height: ${({ $show }) => ($show ? "80" : "0")}px;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  overflow: hidden;
  padding: 2px 0 var(--lip);
  transition:
    max-height var(--dur-base) var(--ease-bounce),
    opacity var(--dur-base) var(--ease-out);
`;

export const TimerPill = styled.div<{ $level: ClockLevel; $tick: boolean }>`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  min-width: 112px;
  padding: 6px var(--space-4) 8px;
  border-radius: var(--radius-lg);
  background: ${({ $level }) => LEVELS[$level][0]};
  color: ${({ $level }) => LEVELS[$level][1]};
  border: var(--border-w) solid ${({ $level }) => LEVELS[$level][2]};
  box-shadow: 0 3px 0 ${({ $level }) => LEVELS[$level][2]};
  transition: background var(--dur-base), color var(--dur-base), border-color var(--dur-base);

  ${({ $level, $tick }) =>
    $level !== "calm" &&
    $tick &&
    css`
      animation: shake 400ms var(--ease-out);
    `}
`;

export const TimerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  font-family: var(--font-display);
  font-weight: 700;
  font-size: var(--text-lg);
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
`;

export const Track = styled.div`
  height: 6px;
  border-radius: var(--radius-full);
  background: var(--card-sunken);
  border: 1px solid var(--line);
  overflow: hidden;
`;

export const Fill = styled.div<{ $level: ClockLevel }>`
  height: 100%;
  border-radius: inherit;
  background: ${({ $level }) => LEVELS[$level][3]};
  transition: width 1s linear, background var(--dur-base);
`;
